import React from 'react';
import Svg, {Path} from 'react-native-svg';

interface NovaAIChatWindowIconProps {
  /** Background fill color of the rounded-rect container.
   *  Light mode: #EAF2FB  |  Dark mode: #2B78CA */
  bgColor?: string;
  /** Stroke color for all icon paths.
   *  Light mode: #2B78CA  |  Dark mode: #EAF2FB */
  color?: string;
}

export const NovaAIChatWindowIcon = ({
  bgColor = '#EAF2FB',
  color = '#2B78CA',
}: NovaAIChatWindowIconProps) => (
  <Svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <Path
      d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
      fill={bgColor}
    />
    <Path
      d="M19.9999 14.4997V10.833H16.3333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M22.75 19.083V20.9163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M10.8333 20H12.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M27.3333 20H29.1666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M27.3334 23.6667C27.3334 24.1529 27.1403 24.6192 26.7964 24.963C26.4526 25.3068 25.9863 25.5 25.5001 25.5H17.0924C16.6062 25.5001 16.14 25.6933 15.7962 26.0372L13.7777 28.0557C13.6867 28.1467 13.5708 28.2086 13.4445 28.2337C13.3183 28.2589 13.1874 28.246 13.0685 28.1967C12.9496 28.1475 12.848 28.0641 12.7765 27.957C12.7049 27.85 12.6668 27.7242 12.6667 27.5955V16.3333C12.6667 15.8471 12.8599 15.3808 13.2037 15.037C13.5475 14.6932 14.0139 14.5 14.5001 14.5H25.5001C25.9863 14.5 26.4526 14.6932 26.7964 15.037C27.1403 15.3808 27.3334 15.8471 27.3334 16.3333V23.6667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M17.25 19.083V20.9163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
